import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    keypointRuns: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdGroupId: null,
    keypointRunId: null,
    keypointDatasets: [],
    kpdsCount: 0,
    kpdsPage: 1,
    kpdsPageSize: 5,
    kpdsPages: 0,
    kpdsSortField: 'created_at',
    kpdsSortOrder: 'desc',
    kpdsSearch: null,
    kpdsError: ''
}

const receivedKeypointsData=(state, action)=>{
    const { keypointRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        keypointRuns: keypointRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId
    }
}

const unknownServerError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedKeypointDatasets=(state, action)=>{
    const { keypointDatasets,keypointRunId,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        keypointRunId: keypointRunId,
        keypointDatasets: keypointDatasets,
        kpdsCount: count,
        kpdsPage: page,
        kpdsPageSize: pageSize,
        kpdsPages: pages,
        kpdsSortField: sortField,
        kpdsSortOrder: sortOrder,
        kpdsSearch: search
    }
}

const getKeypointDatasetsUnknownServerError=(state, action)=> {
    return {
        ...state,
        kpdsError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_KEYPOINT_DATA]: receivedKeypointsData,
    [actionTypes.GET_KEYPOINT_DATA_ERROR]: unknownServerError,
    [actionTypes.GET_KP_DATASET_DATA]: receivedKeypointDatasets,
    [actionTypes.GET_KP_DATASET_DATA_ERROR]: getKeypointDatasetsUnknownServerError
});


// WEBPACK FOOTER //
// ./src/redux/keypoint/reducer.js